import GenericScreenLayout from "src/layouts/GenericScreenLayout";
import ApplicationPromoSent from "src/components/StoresPromosComponent/ApplicationPromoSent";

const ApplicationPromoSentComponent = () => {
  return (
    <div data-testid={'application-promo-sent-component'}>
      <GenericScreenLayout>
        <GenericScreenLayout.MainContent
          mainContent={<ApplicationPromoSent />}
        />
      </GenericScreenLayout>
    </div>
  );
};

export default ApplicationPromoSentComponent;